// dependencies
import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";

// components
import buildGraphs from "./Graphs";
import PageSpinner from "Components/Spinner/PageSpinner";

// actions

// selectors

// css
import css from "./TimeSeries";

export default class BarChart extends React.PureComponent {
	static propTypes = {
		graphWidth: PropTypes.number.isRequired,
		data: PropTypes.instanceOf(Map).isRequired,
	};

	constructor(props) {
		super(props);

		this.svgContainer = React.createRef();
	}

	componentDidMount() {}

	componentDidUpdate() {
		const { graphWidth, data } = this.props;

		const checks = [graphWidth > 0, data.size > 0];

		if (checks.filter((value) => !value).length === 0) {
			buildGraphs(this.svgContainer.current, { data });
		}
	}

	render() {
		const { data } = this.props;

		if (data.size === 0) {
			return <PageSpinner />;
		}

		return <div className={`${css.SVGContainer}`} ref={this.svgContainer} />;
	}
}
